import {
  UPDATE_INVITE_DRIVER_DETAILS,
  UPDATE_PASSWORD_DETAILS,
} from "../constants";

export const updateInviteDriverDetails = (data) => ({
  type: UPDATE_INVITE_DRIVER_DETAILS,
  payload: data,
});

export const updatePasswordDetails = (data) => ({
  type: UPDATE_PASSWORD_DETAILS,
  payload: data,
});
